import reducer from './reducer';
import * as actions from './actions';

export { actions };

export default reducer;
